import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

import playIcon from 'images/icons/invite/play.svg';
import Tooltip from 'components/ui/Tooltip';

import { useContext } from '../Context';

export default function ApproveTrainingAction({ affiliateId }) {
  const { dispatch, actions } = useContext();

  const approveTraining = (e) => {
    swal(
      {
        title: '',
        text: 'Do you want to approve training of this affiliate user?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Approve',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      (isConfirm) => {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== 'BUTTON') {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          actions.approveTraining(dispatch, affiliateId);
        }
      },
    );
  };

  return (
    <>
      <Button
        bsStyle="link"
        className="pl0 pr0 mr5"
        onClick={(e) => approveTraining(e)}
        data-tip="Approve Training"
      >
        <img src={playIcon} alt="approve training" />
      </Button>

      <Tooltip />
    </>
  );
}

ApproveTrainingAction.propTypes = {
  affiliateId: PropTypes.string.isRequired,
};
